import MamWalletView from "@/views/mamWallet/MamWalletView.vue";
import MamWalletInternalTransferForm from "@/views/mamWallet/InternalTransfer/MamWalletInternalTransferForm.vue";
import MamWalletWithdrawForm from "@/views/mamWallet/Withdraw/MamWalletWithdrawForm.vue";

export default {
  MamWalletView,
  MamWalletInternalTransferForm,
  MamWalletWithdrawForm
};